import React from "react";
import { Modal, Button } from "react-bootstrap";

const AccountDeactivatedModal = ({ show, onConfirm }) => {
  //   console.log("🎭 AccountDeactivatedModal render:", { show, onConfirm });

  const animationStyles = `
    @keyframes danger-pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.1);
        opacity: 0.8;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }

    @keyframes glow-pulse {
      0%, 100% {
        opacity: 0.3;
        transform: translate(-50%, -50%) scale(1);
      }
      50% {
        opacity: 0.6;
        transform: translate(-50%, -50%) scale(1.2);
      }
    }

    @keyframes shake-in {
      0% {
        transform: translateY(-20px) scale(0.9);
        opacity: 0;
      }
      50% {
        transform: translateY(5px) scale(1.02);
        opacity: 1;
      }
      100% {
        transform: translateY(0) scale(1);
        opacity: 1;
      }
    }

    .danger-icon {
      font-size: 4rem;
      color: var(--theme-primary);
      animation: danger-pulse 2s infinite;
      filter: drop-shadow(0 4px 8px rgba(220, 53, 69, 0.3));
    }

    .danger-icon-container {
      position: relative;
      display: inline-block;
      margin-bottom: 1rem;
    }

    .danger-icon-container::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100px;
      height: 100px;
      background: radial-gradient(circle, rgba(220, 53, 69, 0.2) 0%, transparent 70%);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
      animation: glow-pulse 2s infinite;
    }

    .modal-content {
      animation: shake-in 0.6s ease-out;
    }
  `;

  return (
    <>
      <style>{animationStyles}</style>
      <Modal
        show={show}
        onHide={() => {}} // Prevent closing by clicking outside or X button
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="pt-2">
          <div className="text-center py-3">
            {/* Animated Exclamation Icon */}
            <div className="mb-4">
              <div className="danger-icon-container">
                <span
                  className="danger-icon"
                  style={{ fontFamily: "Arial, sans-serif" }}
                >
                  ⚠
                </span>
              </div>
            </div>

            {/* Main Message */}
            <h5 className="mb-3 fw-semibold text-dark">
              Your account has been deactivated by admin
            </h5>

            {/* Subtitle */}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0">
          <Button
            variant="primary"
            onClick={onConfirm}
            size="lg"
            className="px-4 fw-semibold"
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccountDeactivatedModal;
